import { MeiliSearch } from 'meilisearch';

if (!process.env.REACT_APP_MEILISEARCH_API_KEY) {
  throw new Error(
    'REACT_APP_MEILISEARCH_API_KEY is not defined in environment variables'
  );
}

if (!process.env.REACT_APP_MEILISEARCH_INDEX_NAME) {
  throw new Error(
    'REACT_APP_MEILISEARCH_INDEX_NAME is not defined in environment variables'
  );
}

export const client = new MeiliSearch({
  host:
    process.env.REACT_APP_MEILISEARCH_HOST || 'https://ms-09a799db5751-31197.fra.meilisearch.io',
  apiKey: process.env.REACT_APP_MEILISEARCH_API_KEY,
});

export const INDEX_NAME = process.env.REACT_APP_MEILISEARCH_INDEX_NAME;

/**
 * Retourne le label pour un type de suggestion
 * @param {import('src/lib/type').SearchHitType} type - Le type de suggestion
 * @returns {string} Le label du type
 */
export const getTypeLabel = (type) => {
  switch (type) {
    case 'category':
      return 'Category';
    case 'subcategory':
      return 'Subcategory';
    case 'product':
      return 'Product';
    case 'company':
      return 'Company';
    default:
      return type;
  }
};